import { createRoot } from 'react-dom/client';

import { RequestManagerProvider } from './shared/providers/RequestManagerProvider';
import { HomeAppProvider } from './shared/providers/HomeAppProvider';
import { HOME_BASENAME } from './shared/routing/HomeRoutes';
import { RM_BASENAME } from './shared/routing/RequestManagerRoutes';

const matchBasename = (pathname: string, basename: string) =>
    pathname === basename || pathname.startsWith(`${basename}/`);

const resolveApp = (pathname: string) => {
    if (matchBasename(pathname, HOME_BASENAME)) return <HomeAppProvider />;
    if (matchBasename(pathname, RM_BASENAME)) return <RequestManagerProvider />;
};

const renderApp = () => {
    const root = createRoot(document.getElementById('app') as HTMLElement);
    root.render(resolveApp(window.location.pathname));
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderApp);
} else {
    renderApp();
}
